import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
  type Prices,
} from "@b2bportal/core-types";
import type { RoomProduct } from "@b2bportal/lodging-api";
import { useHotelRoomRate } from "@tenant/hotels";
import clsx from "clsx";
import defaultStyles from "./HotelRoomRate.module.scss";
import { useHotelsConfig } from "~core-hotels/context";

export interface HotelRoomRateProps extends PlatformComponentProps {
  product: RoomProduct;
  priceDifference?: Prices;
}

const COMPONENT_KEY = CoreHotelsComponent.HotelRoomRate;

export const HotelRoomRate = (props: HotelRoomRateProps) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { className, children } = props;

  const { enableMealPlans } = useHotelsConfig();
  const { text, mealPlans } = useHotelRoomRate(props);

  return (
    <div className={clsx(block, className)}>
      {enableMealPlans && mealPlans ? (
        <>
          <div className={cn("title")}>{mealPlans.planName}</div>
          <div className={cn("subtitle")}>{mealPlans.subtitle}</div>
          {mealPlans.finePrint != null ? (
            <div className={cn("fine-print")}>{mealPlans.finePrint}</div>
          ) : null}
        </>
      ) : (
        <>
          <div className={cn("title")}>{text.title}</div>
          {text.subtitle != null ? (
            <div className={cn("subtitle")}>{text.subtitle}</div>
          ) : null}
        </>
      )}
      {children}
    </div>
  );
};

/**
 * @deprecated use HotelRoomRateProps instead
 * this is a temporary alias for backwards compatibility
 */
export type HotelRoomRatesComponentProps = HotelRoomRateProps;

/**
 * @deprecated use HotelRoomRate instead
 * this is a temporary alias for backwards compatibility
 */
export const HotelRoomRates = HotelRoomRate;
